module.exports = __webpack_public_path__ + "static/work1-6f8fce28abe13ed2460cae5794d78931.jpg";